/* ==========================================================================
   Visotale — Cart Drawer
   ========================================================================== */

(function() {
  'use strict';

  const drawer = document.querySelector('[data-cart-drawer]');
  const overlay = document.querySelector('[data-cart-drawer-overlay]');
  if (!drawer) return;

  // Free shipping threshold
  const FREE_SHIPPING_THRESHOLD = 1000 * 100; // 1000₺ in cents

  function openDrawer() {
    drawer.classList.add('is-active');
    overlay.classList.add('is-active');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    drawer.classList.remove('is-active');
    overlay.classList.remove('is-active');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  // Expose globally for wizard
  window.VisotaleCart = window.VisotaleCart || {};
  window.VisotaleCart.openDrawer = openDrawer;
  window.VisotaleCart.closeDrawer = closeDrawer;

  // Cart icon → opens drawer (override default redirect)
  const cartToggles = document.querySelectorAll('[data-cart-toggle]');
  cartToggles.forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      openDrawer();
    }, true); // capture phase = global.js'in handler'ından önce çalışır
  });

  // Close button & overlay
  document.querySelectorAll('[data-cart-drawer-close]').forEach(function(btn) {
    btn.addEventListener('click', closeDrawer);
  });

  if (overlay) {
    overlay.addEventListener('click', closeDrawer);
  }

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && drawer.classList.contains('is-active')) {
      closeDrawer();
    }
  });

  // ==========================================================================
  // Cart refresh - drawer içeriğini yeniden çek
  // ==========================================================================
  async function refreshCartDrawer() {
    try {
      // Cart section'ı sunucudan al
      const response = await fetch('/?section_id=' + encodeURIComponent('cart-drawer-refresh'));
      // Daha basit yöntem: cart.js'ten data al, manuel render et
      const cartResp = await fetch('/cart.js');
      const cart = await cartResp.json();
      renderCartDrawer(cart);
    } catch (err) {
      console.error('Cart drawer refresh failed:', err);
    }
  }

  function renderCartDrawer(cart) {
    const itemsContainer = drawer.querySelector('[data-cart-drawer-items]');
    const footer = drawer.querySelector('[data-cart-drawer-footer]');
    const countEl = drawer.querySelector('[data-cart-drawer-count]');
    const subtotalEl = drawer.querySelector('[data-drawer-subtotal]');
    const shippingEl = drawer.querySelector('[data-drawer-shipping]');
    const totalEl = drawer.querySelector('[data-drawer-total]');
    const progressFill = drawer.querySelector('[data-shipping-fill]');
    const progressText = drawer.querySelector('[data-shipping-text]');
    const progressWrap = drawer.querySelector('[data-shipping-progress]');

    // Count
    if (countEl) countEl.textContent = '(' + cart.item_count + ')';

    // Items
    if (itemsContainer) {
      if (cart.item_count === 0) {
        itemsContainer.innerHTML = '<div class="vt-drawer-empty">' +
          '<div class="vt-drawer-empty-icon">' +
          '<svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.25">' +
          '<path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z" stroke-linecap="round" stroke-linejoin="round"/>' +
          '<line x1="3" y1="6" x2="21" y2="6" stroke-linecap="round"/>' +
          '<path d="M16 10a4 4 0 01-8 0" stroke-linecap="round"/></svg>' +
          '</div>' +
          '<h3>Sepetin boş.</h3>' +
          '<p>Bir fotoğrafını yükle, yapay zeka senin için sanat eseri yaratsın.</p>' +
          '</div>';
        if (footer) footer.hidden = true;
        return;
      }

      const itemsHtml = cart.items.map(function(item, index) {
        // Properties (only user-visible, not _ prefixed)
        let metaHtml = '';
        if (item.properties) {
          const visibleProps = Object.entries(item.properties)
            .filter(function([key, val]) {
              return !key.startsWith('_') && val;
            })
            .map(function([key, val]) { return '<span>' + escapeHtml(val) + '</span>'; });
          if (visibleProps.length > 0) {
            metaHtml = '<div class="vt-drawer-item-meta">' + visibleProps.join('') + '</div>';
          }
        }

        const imgHtml = item.image
          ? '<img src="' + item.image.replace(/(\.(jpg|jpeg|png|webp))/, '_200x$1') + '" alt="' + escapeHtml(item.product_title) + '">'
          : '<div class="vt-artwork-oil" style="width:100%;height:100%;"></div>';

        return '<div class="vt-drawer-item" data-cart-line="' + (index + 1) + '">' +
          '<div class="vt-drawer-item-image">' + imgHtml + '</div>' +
          '<div class="vt-drawer-item-info">' +
            '<div class="vt-drawer-item-title">' + escapeHtml(item.product_title) + '</div>' +
            metaHtml +
            '<div class="vt-drawer-item-bottom">' +
              '<span class="vt-drawer-item-price">' + formatMoney(item.final_line_price) + '</span>' +
              '<button type="button" class="vt-drawer-item-remove" data-cart-remove data-line="' + (index + 1) + '">Kaldır</button>' +
            '</div>' +
          '</div>' +
          '</div>';
      }).join('');

      itemsContainer.innerHTML = itemsHtml;

      // Re-attach remove handlers
      itemsContainer.querySelectorAll('[data-cart-remove]').forEach(function(btn) {
        btn.addEventListener('click', function() {
          removeCartItem(parseInt(btn.dataset.line));
        });
      });
    }

    // Footer
    if (footer) footer.hidden = false;
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
    if (totalEl) totalEl.textContent = formatMoney(cart.total_price);

    // Shipping
    if (progressWrap && progressFill && progressText) {
      const earned = cart.total_price >= FREE_SHIPPING_THRESHOLD;
      const pct = Math.min(100, (cart.total_price / FREE_SHIPPING_THRESHOLD) * 100);
      progressFill.style.width = pct + '%';
      progressWrap.classList.toggle('is-completed', earned);
      if (earned) {
        progressText.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="var(--vt-accent)" stroke-width="2"><polyline points="20 6 9 17 4 12"/></svg><span><strong>Ücretsiz kargo kazandın</strong></span>';
        if (shippingEl) shippingEl.innerHTML = '<span style="color:var(--vt-accent);">Ücretsiz</span>';
      } else {
        const remaining = FREE_SHIPPING_THRESHOLD - cart.total_price;
        progressText.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="1" y="3" width="15" height="13" rx="1"/></svg><span><strong>' + formatMoney(remaining) + '</strong> kaldı ücretsiz kargoya</span>';
        if (shippingEl) shippingEl.textContent = 'Checkout\'ta hesaplanır';
      }
    }
  }

  function escapeHtml(s) {
    return String(s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function formatMoney(cents) {
    const lira = (cents / 100).toLocaleString('tr-TR', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
    return lira + '₺';
  }

  async function removeCartItem(line) {
    try {
      const resp = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: 0 })
      });
      const cart = await resp.json();
      renderCartDrawer(cart);
      if (window.VisotaleCart && window.VisotaleCart.updateCount) {
        window.VisotaleCart.updateCount(cart.item_count);
      }
    } catch (err) {
      console.error('Item remove failed:', err);
    }
  }

  // Initial state — server tarafında zaten render edildi, ama JS state'iyle senkronize tutmak için
  // Drawer ilk açıldığında refresh çağırılırsa tutarsızlık olmaz
  window.VisotaleCart.refreshDrawer = refreshCartDrawer;
})();
